var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNebl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#50479E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4525 7.6838V10.3748L9.02981 11.7062V9.01636L11.4519 7.68493L11.4525 7.6838ZM14.3438 6.99418V11.0054C14.3438 11.2906 14.265 11.5696 14.1171 11.812C13.9708 12.0539 13.7587 12.2592 13.4961 12.4037L11.6893 13.3966V10.7494L11.9177 10.624V7.42955L14.1306 6.21286C14.2678 6.44911 14.3438 6.7163 14.3438 6.99474V6.99418ZM4.50394 12.4037C4.25763 12.2692 4.04956 12.0743 3.89925 11.8373C3.7411 11.5888 3.65683 11.3005 3.65625 11.0059V8.43755L6.14475 10.381V10.489L6.14869 10.6004L6.34219 10.7146L8.82619 12.0803L9.03094 12.1928V14.6251C8.72435 14.6312 8.42148 14.5571 8.15231 14.4102L4.50394 12.4032V12.4037ZM4.40044 5.6588L7.03125 4.2188L8.82 5.9513L6.14475 7.42674V7.65174L3.66188 9.01524L3.65625 6.99361C3.65625 6.70843 3.735 6.4283 3.88406 6.18586C4.01456 5.97211 4.19119 5.79211 4.40044 5.65824V5.6588ZM13.4961 5.59636C13.7596 5.74027 13.9789 5.9532 14.1306 6.2123L11.9177 7.42899V7.40874L11.6893 7.2833L9.25144 5.94343L11.6893 4.60299L13.4961 5.59636ZM3.66188 9.01636L6.14475 7.65174V10.381L3.66188 9.01636ZM9.03094 5.8388V3.37505C9.31665 3.37939 9.597 3.45334 9.84769 3.59049L11.6893 4.60299L9.25144 5.94286L9.03094 5.8388ZM8.82619 5.9513L6.34669 4.58893L8.26031 3.53649C8.50177 3.42538 8.76519 3.37019 9.03094 3.37505V5.8388L8.82619 5.9513ZM9.04669 12.2012L9.25144 12.0887L11.6601 13.4129L9.84769 14.4096C9.59694 14.5465 9.3166 14.6208 9.03094 14.6251V12.1928L9.04669 12.2012ZM11.6893 10.7489V13.3966L11.6601 13.4129L9.25144 12.0887L11.6893 10.7489Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNebl);
export default __webpack_public_path__ + "static/media/nebl.dcb8c38c97c487053dab57c85c72f721.svg";
export { ForwardRef as ReactComponent };